import BaseFileLoadPageMixin from "@/modules/core/file/protected/BaseFileLoadPageMixin";
import Editor from "./CreditAssignmentFileEditor";
import service from "./CreditAssignmentFileService";

export default {
  mixins: [BaseFileLoadPageMixin],

  components: {
    Editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.title;
    }
  }
};
